import {css, CreateSheet} from 'aphrodite';
import React, {HTMLAttributes, PropsWithChildren, useEffect, useLayoutEffect, useRef, useState} from 'react';

type SimpleCollapseProps = PropsWithChildren<
    HTMLAttributes<HTMLDivElement> & {
        collapse: boolean;
        duration?: number;
    }
>;

export default function SimpleCollapse({children, collapse, duration = 300, ...rest}: SimpleCollapseProps) {
    const elementRef = useRef<HTMLDivElement>(null);
    const [contentHeight, setContentHeight] = useState(0);
    const [isRendered, setIsRendered] = useState(false);

    useLayoutEffect(() => {
        const el = elementRef.current;
        if (!el) return;
        setContentHeight(el.scrollHeight);
        setIsRendered(true);
    }, [children]);

    useEffect(() => {
        if (collapse) return;
        const el = elementRef.current;
        if (!el) return;
        setContentHeight(el.scrollHeight);
    }, [collapse]);

    return (
        <div
            {...rest}
            ref={elementRef}
            className={`${css(Styles.element)} ${rest.className || ''}`}
            style={{
                maxHeight: collapse ? 0 : contentHeight,
                visibility: isRendered ? 'visible' : 'hidden',
                transition: `max-height ${duration}ms ease`,
                ...rest.style,
            }}
        >
            {children}
        </div>
    );
}

const Styles = CreateSheet({
    element: {
        overflow: 'hidden',
    },
});
